import type { components } from "../api/schema";

type AnswerResponse = components["schemas"]["AnswerResponse"];
type EvalStatus = components["schemas"]["EvalStatus"];

export function answerStatusLabel(status: EvalStatus | null): string {
  if (status === "not_eligible") {
    return "Not eligible";
  }
  if (status === "failed") {
    return "Failed";
  }
  if (status === "ok") {
    return "OK";
  }
  return "-";
}

export function answerStatusTone(
  status: EvalStatus | null,
): "danger" | "neutral" | "success" {
  // `ok` means the evaluation RAN, not that the call passed. Rendering it
  // green made every row read as good at a glance and competed with the
  // Value column, which is the actual verdict. Only failure earns colour.
  if (status === "ok") {
    return "neutral";
  }
  if (status === "failed") {
    return "danger";
  }
  return "neutral";
}

export function eligibilityReasonMessage(answer: AnswerResponse): string {
  return (
    answer.eligibility_reason?.message ??
    "The available input is not eligible for this marker."
  );
}
